<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划新增单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        disabled
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input
                v-model="conditions.plan_order"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划新增单" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划编号">
              <el-input v-model="conditions.plan_number" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="提报类型" prop="report_type">
              <el-select v-model="conditions.report_type" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0001']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号" prop="customer">
              <el-input
                v-model="conditions.customer"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.cust_name"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.customer_type"
                type="text"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="plan_type">
              <el-select v-model="conditions.plan_type" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类" prop="wlybrand">
              <el-select v-model="conditions.wlybrand" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0019']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度" prop="gjahr">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月份" prop="monat">
              <el-date-picker
                v-model="conditions.monat"
                type="month"
                format="MM"
                value-format="MM"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="计划量" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划量（件)">
                  <el-input
                    v-model="conditions.initplan_qty"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24" v-if="conditions.plan_type==='V088'">
            <common-title title="计划量" style="visibility: hidden;"/>
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划量（瓶)">
                  <el-input
                    v-model="conditions.initplan_bot"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="计划额(参考)" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划额（万元）">
                  <el-input
                    v-model="conditions.initplan_amt"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <el-input
                v-model="conditions.sal_center_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.sal_base_text" type="text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input v-model="conditions.region_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.city_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                v-model="conditions.sales_emp_name"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select v-model="conditions.porder_status" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0025']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input v-model="conditions.audit_comment" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="550"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanByNumber } from '@/api/sap/sale-plan'
import { apiSapClientFindInfo } from '@/api/common'

export default {
  data() {
    return {
      selectDataOptions: {},
      loading: false,
      conditions: {
        id: '',
        uname: '',
        datum: '',
        porder_status: 'E001',
        plan_order: '',
        order_type: 'ZP01',
        plan_number: '',
        report_type: '',
        customer: '',
        customer_type: '',
        cust_name: '',
        plan_type: '',
        wlybrand: '',
        gjahr: '',
        monat: '',
        sal_center: '',
        sal_base: '',
        region: '',
        region_text: '',
        city: '',
        city_text: '',
        sales_emp: '',
        sales_emp_name: '',
        initplan_qty: '',
        initplan_amt: '',
        remark: '',
        audit_comment: '',
        sal_base_text: '',
        sal_center_name: ''
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      }
    }
  },
  computed: {
  },
  created() {
    // 销售计划变更原因 字典：A0003
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0001')
    this.getSelectDictDataOrigin('A0025')
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0009')
    this.salePlanCountFindById()
  },

  methods: {
    async salePlanCountFindById() {
      const { data } = await getSalePlanByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data?.ls_head || {})
      this.gridOptions.data = data?.lt_chg_history || []
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 24px 16px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanCheck.vue